import React from 'react';

import { useTitle } from 'src/hooks/useTitle';

import { ServiceMetrics } from '../ServiceMetrics';

export const PrimeMetrics: React.FC = () => {
    useTitle('Prime Metrics');

    return (
        <ServiceMetrics
            serviceName="Prime"
            title="Prime Licensing KPI's"
            description="View and analyze detailed Prime licensing KPI's - STEMP level data with advanced filtering and export capabilities"
            serviceId={2}
        />
    );
};
